module.exports = __webpack_public_path__ + "static/media/archive.1ac002b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/archive.jpg
// module id = 1631
// module chunks = 0